export default __webpack_public_path__ + "static/mechit-91954fa3d03b76b87446ff13cdc3e344.jpg";